import type { ReactNode } from 'react'
import { useCatalogueImage } from '../../lib/shop/catalogueImage'

interface ProductThumbProps {
  url: string | null | undefined
  alt?: string
  className: string
  /** Shown when there is no image, or while a failed link is being replaced. */
  fallback: ReactNode
}

/** A catalogue product image that replaces an expired signed link with a fresh one (BUG-522). */
export default function ProductThumb({ url, alt = '', className, fallback }: ProductThumbProps) {
  const { src, onError } = useCatalogueImage(url ?? null)
  return src ? <img src={src} alt={alt} className={className} onError={onError} /> : <>{fallback}</>
}
